import { store } from "../store";
import appConfig from "../appconfig";
import { BifrostBackendApi, BifrostBackendNestApi } from "../gateways/BifrostBackendApi";

const getApi = () => {
	const useNestOrderPaymentFlow =
		store.getters.featureToggles &&
		store.getters.featureToggles.useNestOrderPaymentFlow;
	return useNestOrderPaymentFlow ? BifrostBackendNestApi : BifrostBackendApi;
};

const FoodCategoriesProvider = Object.freeze({
	async getFoodCategories() {
		const foodCategoriesQueryParams = {
			tenantId: appConfig.tenantId
		};

		const [foodCategories] = await Promise.all([
			getApi().get("/food-categories", {
				params: foodCategoriesQueryParams
			})
		]);
		return {
			foodCategories
		};
	},
	getFoodCategory(id, tenantId, jwtToken) {
		return getApi().get(`/food-categories/?id=${id}&tenantId=${tenantId}`, {
			headers: {
				Authorization: jwtToken
			}
		});
	}
});

export default FoodCategoriesProvider;
